const INSURER_SUPPORT = "INSURER_SUPPORT";
const INSURER_VIEW_ONLY = "INSURER_VIEW_ONLY";
const ADMIN = "ADMIN";
const VITRAYA_SUPPORT = "VITRAYA_SUPPORT";
const IFRAME_USER = "IFRAME_USER";
const EXTERNAL_API_SUPPORT = "EXTERNAL_API_SUPPORT";
const API_USER = "API_USER";
const USER = localStorage.getItem("role");

export const UserTypes = [
    {name: "Admin", id: ADMIN},
    {name: "Insurer Edit User", id: INSURER_SUPPORT},
    {name: "Insurer View Only", id: INSURER_VIEW_ONLY},
    {name: "Vitraya Support", id: VITRAYA_SUPPORT},
];

export const isInsurerUser = () => {
    return USER === INSURER_SUPPORT || USER === INSURER_VIEW_ONLY;
};

export const isNotInsurerReadOnlyUser = () => {
    return USER !== INSURER_VIEW_ONLY;
};

export const isVitrayaUser = () => {
    const USER = localStorage.getItem("role");
    return USER === VITRAYA_SUPPORT;
}

export const isAdminUser = () => {
    const USER = localStorage.getItem("role");
    return USER === ADMIN;
}

export const isNotINSURER_VIEW_ONLY = (USER) => {
    return USER !== INSURER_VIEW_ONLY;
}

export const isIframeUser = () => {
    return USER === IFRAME_USER;
}

export const isIframeAndInsurerUser = () => {
    return USER === IFRAME_USER || isInsurerUser(USER);
}

export const isIframeAndAdminUser = () => {
    const USER = localStorage.getItem("role");
    if(USER){
        return USER === IFRAME_USER || isAdminUser(USER) || isNotINSURER_VIEW_ONLY(USER);
    }
}

export const isVitrayaInternalUser = () => {
    return isVitrayaUser(USER) || isAdminUser(USER);
}

export const isBajajInsurer = () => {
    return getLocalStorageHospitalCode() === "INSURER-1003";
}

export const isAbhiInsurer = () => {
    return getLocalStorageHospitalCode() === "INSURER-1002";
}

export const isStarInsurer = () => {
    return getLocalStorageHospitalCode() === "INSURER-1001";
}

export const isApiUserAndIframeUser = () => {
    return USER === API_USER || USER === EXTERNAL_API_SUPPORT || isIframeUser();
}

export const getLocalStorageHospitalCode = () => {
    return localStorage.getItem("hospitalCode");
}